var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({ref:"editable",staticClass:"content-editable",class:{ focused: _vm.focused },attrs:{"contenteditable":""},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false}}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }